var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$auth.check())?[_c('AppSidebar'),_c('div',{staticClass:"content-wrapper"},[_c('AlertMsg'),_c('router-view')],1)]:[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }